import React from "react";
import {
    RadialChart,
    XYPlot,
    VerticalBarSeries,
    XAxis,
    YAxis,
} from "react-vis";

const JobGraph = (props) => {
    const newMemberJob = [];
    const updateMemberJob = [];
    const newMemberJobFailedOn = [];
    const updateMemberJobFailedOn = [];

    if (props.newMemberJob && props.newMemberJob.success) {
        newMemberJob.push(
            {
                angle: props.newMemberJob.success,
                label: `${props.newMemberJob.success} Success`,
            },
            {
                angle: props.newMemberJob.failed,
                label: `${props.newMemberJob.failed} Failed`,
            }
        );
    }

    if (props.newMemberJobFailedOn) {
        Object.entries(props.newMemberJobFailedOn).forEach(
            ([label, angle]) => {
                newMemberJobFailedOn.push({
                    y: parseInt(angle),
                    x: label,
                });
            }
        );
    }

    if (props.updateMemberJob && props.updateMemberJob.success) {
        updateMemberJob.push(
            {
                angle: props.updateMemberJob.success,
                label: `${props.updateMemberJob.success} Success`,
            },
            {
                angle: props.updateMemberJob.failed,
                label: `${props.updateMemberJob.failed} Failed`,
            }
        );
    }

    if (props.updateMemberJobFailedOn) {
        Object.entries(props.updateMemberJobFailedOn).forEach(
            ([x, y]) => {
                updateMemberJobFailedOn.push({
                    y: parseInt(y),
                    x: x,
                });
            }
        );
    }

    const colors = ["#ff8b94", "#00d5a6"];
    const diamention = 300;

    const handleValueClick = (value, name) => {
        console.log(value.color);
        console.log(name);
        const details = {
            type: name,
            column: "status",
            token: value.color == 0 ? "failed" : "success",
            endPoint: "job"
        };
        props.apiStatsFunction(details);
    };

    return (
        <div
            style={{ display: "flex", flexWrap: "wrap", marginBottom: "20px" }}
        >
            {newMemberJob.length > 0 && (
                <div style={{ flex: 1 }}>
                    <h3 className="sub-title text--muted">New Member Job</h3>
                    <RadialChart
                        name="givex"
                        data={newMemberJob}
                        width={diamention}
                        height={diamention}
                        showLabels
                        labelsRadiusMultiplier={1.1}
                        colorRange={colors}
                        animation
                        onValueClick={(value) => handleValueClick(value, "new_member")}
                    />
                </div>
            )}
            {newMemberJobFailedOn.length > 0 && (
                <div style={{ flex: 1 }}>
                    <h3 className="sub-title text--muted">New Member: Failed On</h3>
                    <XYPlot xType="ordinal" width={diamention} height={diamention}>
                        <XAxis />
                        <YAxis />
                        <VerticalBarSeries
                            data={newMemberJobFailedOn}
                        />
                    </XYPlot>
                </div>
            )}
            {updateMemberJob.length > 0 && (
                <div style={{ flex: 1 }}>
                    <h3 className="sub-title text--muted">Update Member Job</h3>
                    <RadialChart
                        name="futura"
                        data={updateMemberJob}
                        width={diamention}
                        height={diamention}
                        showLabels
                        labelsRadiusMultiplier={1.1}
                        colorRange={colors}
                        animation
                        onValueClick={(value) => handleValueClick(value, "update_member")}
                    />
                </div>
            )}
            {updateMemberJobFailedOn.length > 0 && (
                <div style={{ flex: 1 }}>
                    <h3 className="sub-title text--muted">Update Member: Failed On</h3>
                    <XYPlot xType="ordinal" width={diamention} height={diamention}>
                        <XAxis />
                        <YAxis />
                        <VerticalBarSeries
                            data={updateMemberJobFailedOn}
                        />
                    </XYPlot>
                </div>
            )}
        </div>
    );
};

export default JobGraph;
